import React, { useState } from 'react';
import {
    TextField,
    Button,
    Typography,
    Container,
    Snackbar,
    Alert,
    Box,
    Grid,
} from '@mui/material';
import loginpageimg from '../images/loginPageimg.jpg'

const Createuser: React.FC = () => {
    const [username, setUsername] = useState('');
    const [useremail, setUserEmail] = useState('');
    const [mobile_number, setMobile_number] = useState('');
    const [password, setPassword] = useState('');
    const [responseMessage, setResponseMessage] = useState<string | null>(null);
    const [severity, setSeverity] = useState<'success' | 'error'>('success');

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        const user = {
            username,
            useremail,
            mobile_number,
            password,
        };

        try {   
            const response = await fetch('http://localhost:3000/users', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(user),
            });

            if (!response.ok){
                throw new Error(`HTTP error! status: ${response.status}`);
            } 

            const data = await response.json();
            setResponseMessage('User created successfully');
            setSeverity('success');
        } catch (error) {
            setResponseMessage('Error creating user');
            setSeverity('error');
        }
    };

    const handleCloseSnackbar = () => {
        setResponseMessage(null);
    };

    return (
        <Box
            sx={{
                position: 'fixed', // Use fixed position to cover the entire viewport
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: `url(${loginpageimg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                overflow: 'hidden', // Prevent scrollbars
            }}
        >
            <Grid
                container
                alignItems="center"
                justifyContent="center"
                sx={{
                    height: '100%', // Full height of the parent Box
                }}
            >
                <Grid
                   
                    sx={{
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        padding: 4,
                        borderRadius: 2,
                    }}
                >
                    <Typography variant="h5" gutterBottom>
                        Create Account
                    </Typography>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            margin="normal"
                        />
                        <TextField
                            fullWidth
                            label="Email"
                            value={useremail}
                            onChange={(e) => setUserEmail(e.target.value)}
                            margin="normal"
                        />
                        <TextField
                            fullWidth
                            label="Mobile"
                            value={mobile_number}
                            onChange={(e) => setMobile_number(e.target.value)}
                            margin="normal"
                        />
                        <TextField
                            fullWidth
                            label="Password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            margin="normal"
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            sx={{ mt: 2 }}
                        >
                            Submit
                        </Button>
                    </form>
                </Grid>
            </Grid>

            <Snackbar
                open={!!responseMessage}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
            >
                <Alert onClose={handleCloseSnackbar} severity={severity} sx={{ width: '100%' }}>
                    {responseMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
};


export default Createuser;






{/* <Container maxWidth="sm">
            <Typography variant="h4" gutterBottom>
                Create User
            </Typography>
            <form onSubmit={handleSubmit}>
                <TextField
                    label="Username"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />
                <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={useremail}
                    onChange={(e) => setUserEmail(e.target.value)}
                    required
                />
                <TextField
                    label="Mobile"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    required
                />
                <TextField
                    label="Password"
                    type="password"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <Button type="submit" variant="contained" color="primary">
                    Create User
                </Button>
            </form>
            <Snackbar
                open={!!responseMessage}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
            >
                <Alert onClose={handleCloseSnackbar} severity={severity}>
                    {responseMessage}
                </Alert>
            </Snackbar>
        </Container> */}